import { render } from "./TictactoeShop.vue?vue&type=template&id=94e634cc&scoped=true"
import script from "./TictactoeShop.vue?vue&type=script&lang=js"
export * from "./TictactoeShop.vue?vue&type=script&lang=js"

import "./TictactoeShop.vue?vue&type=style&index=0&id=94e634cc&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e634cc"]])

export default __exports__